module.exports = __webpack_public_path__ + "static/media/Sprinta2017.0e9ebb86.woff";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/FontIcon/fonts/Sprinta2017.woff
// module id = 439
// module chunks = 0 1 2 3 4 5 7 8 11 12 15 16 17 18 20 27